import { computed, reactive, ref } from "vue";
import { ws_instance } from "../websocket/ws-instance";
import { authState } from "./auth";
import { youLeaveState } from "./active_room";
import { goFinish } from "./finishState";
import { isAdmin } from "./adminsState";
import { isHandUp, removeHandUp } from "./handUpState";

export interface UserInRoom {
  avatar: string;
  camera: boolean;
  displayedName: string;
  id: string;
  joined: number;
  micro: boolean;
}

export const usersState = reactive<{ users: UserInRoom[] }>({
  users: [],
});

const usersSet = new Set<string>();

export const selectedOneUserViewId = ref("");

//TODO: переделать сортировку с учетом рук и админов
export const sortedUserList = computed(() => {
  const result: typeof usersState.users = [];
  const admins = usersState.users
    .filter((u) => {
      return isAdmin(u.id);
    })
    .sort((a, b) => {
      return a.displayedName.localeCompare(b.displayedName);
    });
  const hands = usersState.users
    .filter((u) => {
      return !isAdmin(u.id) && isHandUp(u.id);
    })
    .sort((a, b) => {
      return a.displayedName.localeCompare(b.displayedName);
    });
  const other = usersState.users
    .filter((u) => {
      return !isAdmin(u.id) && !isHandUp(u.id);
    })
    .sort((a, b) => {
      return a.displayedName.localeCompare(b.displayedName);
    });
  result.push(...admins, ...hands, ...other);
  return result;
});

export function addOrUpdateUserInList(user: UserInRoom) {
  if (!usersSet.has(user.id)) {
    usersSet.add(user.id);
    usersState.users.push(user);
  } else {
    const funded = usersState.users.find((u) => u.id === user.id);
    if (funded) {
      Object.assign(funded, user);
    }
  }
}

function removeUserInList(uid: string) {
  if (usersSet.has(uid)) {
    usersSet.delete(uid);
    const fundedId = usersState.users.findIndex((u) => u.id === uid);
    if (fundedId > -1) {
      usersState.users.splice(fundedId, 1);
    }
  }
}

export function userExist(id: string) {
  return usersSet.has(id);
}

export function getUserById(id: string) {
  return usersState.users.find((user) => user.id === id);
}

export function findFirstByIds(ids: string[]) {
  for (const id of ids) {
    if (usersSet.has(id)) return getUserById(id) as UserInRoom;
  }
  return null;
}

export const userMap = computed(() => {
  const res: {
    [id: string]: UserInRoom;
  } = {};
  usersState.users.forEach((u) => {
    res[u.id] = u;
  });
  return res;
});

export function subscribeConnectUser() {
  ws_instance.addEventListener("connect-user", (user: UserInRoom) => {
    if (user.id !== authState.id) {
      addOrUpdateUserInList(user);
    }
  });
}
export function subscribeDisconnectUser() {
  ws_instance.addEventListener("disconnect-user", (uid: string) => {
    if (uid === authState.id) {
      youLeaveState.value = true;
    } else {
      removeUserInList(uid);
      removeHandUp(uid);
    }
  });
}

export function subscribeKickUser() {
  ws_instance.addEventListener("user-kicked", (uid: string) => {
    if (uid === authState.id) {
      goFinish("kick");
    } else {
      removeUserInList(uid);
      removeHandUp(uid);
    }
  });
}

export function subscribeUpdateUser() {
  ws_instance.addEventListener("update-user", (user: UserInRoom) => {
    const funded = usersState.users.find((u) => u.id === user.id);
    if (funded) {
      Object.assign(funded, user);
    }
  });
}
